import { useQuery } from '@tanstack/react-query'
import { api } from '@/lib/api'

export interface AIDeployment {
  id: number
  vendor: string
  model: string
  friendly_name?: string
}

// Query key factory
export const aiDeploymentKeys = {
  all: ['aiDeployments'] as const,
  list: (assistantId?: number) =>
    [...aiDeploymentKeys.all, { assistantId }] as const,
}

/**
 * Hook to fetch available AI deployments for the assistant
 * This is used in the Admin Settings tab to select which AI model to use
 */
export function useAIDeployments(assistantId?: number) {
  return useQuery({
    queryKey: aiDeploymentKeys.list(assistantId),
    queryFn: async (): Promise<AIDeployment[]> => {
      const url = assistantId
        ? `/assistants/aideployments?assistant_id=${assistantId}`
        : '/assistants/aideployments'

      const response = await api.get(url)
      return response.data
    },
    staleTime: 5 * 60 * 1000, // Cache for 5 minutes
  })
}
